module.exports = __webpack_public_path__ + "static/img/post_1.f9ce8d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/posts/post_1.png
// module id = 7p6g
// module chunks = 0